import { forwardRef } from 'react';
import Grid, {
    GridExposedMethods,
    GridSettings,
    type OnViewChangedCallback,
} from '~/components/Grid';
import { useReportQuery } from '~/lib/Queries';
import type { FormReportObject } from '~/lib/Api.types';
import { ReportType, TemplateIndex } from '../../ReportsIndexPage/Report.types';
import useColumnsFromKeys from '~/pages/business/ReportEditPage/ReportGrid/useColumnsFromKeys';
import { FormReport } from './FormsGrid.types';

export const FORM_NAME_COLUMN_KEY = 'Form Name';

type FormsGridProps = {
    initialSettings?: GridSettings;
    onViewChanged?: OnViewChangedCallback<FormReportObject>;
    templateSelected?: TemplateIndex;
};

const FormsGrid = forwardRef<GridExposedMethods, FormsGridProps>(
    ({ initialSettings, onViewChanged, templateSelected }, ref) => {
        const {
            data: formsReport,
            isLoading,
            isFetchingNextPage,
        } = useReportQuery(ReportType.Forms);

        const columns = useColumnsFromKeys<FormReport>(
            formsReport,
            ReportType.Forms,
            templateSelected,
        );
        return (
            <Grid<FormReportObject>
                isFetchingMore={isFetchingNextPage}
                ref={ref}
                columns={columns}
                rowData={(formsReport as FormReport)?.data}
                initialSettings={initialSettings}
                onViewChanged={onViewChanged}
                isLoading={isLoading}
            />
        );
    },
);
export default FormsGrid;
